import { Navigate, Route, Routes } from 'react-router-dom';
import { DashboardLayout } from './components/layout';
import { GlobalReauthDialog } from './components/GlobalReauthDialog';
import { RequireAuth } from './components/RequireAuth';
import { LoginPage } from './features/auth/LoginPage';
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { EventsPage } from './features/events/EventsPage';
import { EventDetailPage } from './features/events/EventDetailPage';
import { SeatMapEditorPage } from './features/seatmap/SeatMapEditorPage';
import { PromoCodesPage } from './features/promo/PromoCodesPage';
import { AddOnsPage } from './features/addons/AddOnsPage';
import { CustomQuestionsPage } from './features/questions/CustomQuestionsPage';
import { WaitlistPage } from './features/waitlist/WaitlistPage';
import { OrdersPage } from './features/orders/OrdersPage';
import { OrderDetailPage } from './features/orders/OrderDetailPage';
import { ReportsPage } from './features/reports/ReportsPage';
import { ScannerPage } from './features/scanner/ScannerPage';
import { PayoutsPage } from './features/payouts/PayoutsPage';
import { InvoicesPage } from './features/invoices/InvoicesPage';
import { BrandingPage } from './features/branding/BrandingPage';
import { TemplatesPage } from './features/templates/TemplatesPage';
import { StaffPage } from './features/staff/StaffPage';
import { ApiKeysPage } from './features/apikeys/ApiKeysPage';
import { WebhooksPage } from './features/webhooks/WebhooksPage';
import { DomainsPage } from './features/domains/DomainsPage';
import { PaymentOnboardingPage } from './features/settings/PaymentOnboardingPage';
import { SecurityPage } from './features/settings/SecurityPage';
import { RefundPolicyPage } from './features/settings/RefundPolicyPage';
import { BillingPlanPage } from './features/billing/BillingPlanPage';

export function App() {
  return (
    <>
      <GlobalReauthDialog />
      <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<Navigate to="/events" replace />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="events/:eventId" element={<EventDetailPage />} />
          <Route path="events/:eventId/seat-map" element={<SeatMapEditorPage />} />
          <Route path="promo-codes" element={<PromoCodesPage />} />
          <Route path="add-ons" element={<AddOnsPage />} />
          <Route path="custom-questions" element={<CustomQuestionsPage />} />
          <Route path="waitlist" element={<WaitlistPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/:orderId" element={<OrderDetailPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="scanner" element={<ScannerPage />} />
          <Route path="payouts" element={<PayoutsPage />} />
          <Route path="invoices" element={<InvoicesPage />} />
          <Route path="branding" element={<BrandingPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="staff" element={<StaffPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="webhooks" element={<WebhooksPage />} />
          <Route path="domains" element={<DomainsPage />} />
          <Route path="payment-accounts" element={<PaymentOnboardingPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="refund-policy" element={<RefundPolicyPage />} />
          <Route path="billing" element={<BillingPlanPage />} />
          <Route path="*" element={<Navigate to="/events" replace />} />
        </Route>
      </Route>
      </Routes>
    </>
  );
}
